import React from 'react';
import styled from 'styled-components';

const TituloWrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 0;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    margin-bottom: 14px;
  }
  
  @media (max-width: 400px) {
    margin-bottom: 12px;
  }
`;

const LinhaVertical = styled.div`
  height: 25px;
  margin-right: 12px;
  border-right: 4px solid #00aaaa;
  flex-shrink: 0;
  
  @media (max-width: 600px) {
    height: 22px;
    margin-right: 10px;
    border-right-width: 3px;
  }
  
  @media (max-width: 400px) {
    height: 20px;
    margin-right: 8px;
  }
`;

const TextoTitulo = styled.h1`
  font-size: 18px;
  font-weight: 400;
  color: #8e8e93;
  font-family: "Roboto", sans-serif;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  @media (max-width: 600px) {
    font-size: 17px;
  }
  
  @media (max-width: 400px) {
    font-size: 16px;
  }
`;

const Titulo = ({ children }) => {
  return (
    <TituloWrapper>
      <LinhaVertical />
      <TextoTitulo>{children}</TextoTitulo>
    </TituloWrapper>
  );
};

export default Titulo;
